import * as React from "react"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid2"
import { Box } from "@mui/material"
import { PropaneTank } from "@mui/icons-material"

import { DASHBOARD_ICON_OPACITY_10 } from "../../../utils/constants"
import palette from "../../../theme/palette"
import { fNumber, scaleNumber } from "../../../utils/formatNumber"
import { colorCodes } from "../dash-util"

export function TankProductCard({ data, isTally, litres, index, sx={} }) {

  const typeColor = colorCodes[index] || "#0000ff"

  return (
    <Card sx={{ height: '100%', ...sx }}>
      <CardContent>
        {isTally ? (
          <Typography variant="inherit">{data?.type}</Typography>
        ) : (
            <Stack
              direction="row"
              sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
              spacing={3}
            >
              <Stack
                spacing={1}
                sx={{ borderLeft: `5px solid ${typeColor}`, pl: 2, pt: 0 }}
              >
                <Typography variant="inherit">{data?.type}</Typography>
              </Stack>
              <Box
                sx={{
                  backgroundColor: ` ${typeColor}${DASHBOARD_ICON_OPACITY_10}`,
                  height: "45px",
                  width: "45px",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <PropaneTank sx={{ color: `${typeColor}` }} fontSize="var(--icon-fontSize-lg)" />
              </Box>
            </Stack>
        )}
        {data?.metadata ? (
          <Grid
            container
            spacing={3}
            sx={{
              mt: 2,
              padding: 1,
              backgroundColor: (litres ? 'white' : palette.grey[200]),
              borderRadius: "5px"
            }}
          >
            { data?.metadata?.sort((a, b) => a?.type.localeCompare(b?.type))
              ?.map((d, index) => (
                <Grid
                  key={`tank-capacity-${index}`}
                  size={{ xs: Math.max(4, 12/data?.metadata.length)}}
                  fontSize="12px"
                  fontWeight="normal"
                >
                <Typography sx={{ color: palette.grey[500] }} variant="inherit">
                  &nbsp;{d.type}
                </Typography>
                {fNumber(d.value)}&nbsp;{litres ? <>Ltrs</>: <>m<sup>3</sup></>}
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography sx={{ mt: 3, color: palette.grey[500] }} variant="subtitle1">
            {scaleNumber(data?.value || 0)}
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}
